<template>
  <div>
    <div class="p-0 mb-50">
      <div class="mt-30 container-style mb-30">
        <div class="p-20 activity-form">
          <div>
            <div>
              <div class="p-20 fs-16">
                <router-link :to="{ name: 'study-activities', params: { studyId } }">Activities&nbsp;</router-link>
                <span>/ Create Packet</span>
              </div>
              <div class="row">
                <div class="pt-25  col-12">
                  <div class="tableBg1">
                    <b-row>
                      <b-col cols="10" class="p-0">
                        <h6>
                          <span class="noOfForms">{{ selectedFormsData.length }}</span>
                          <span class="noOfFormsText">Activities Selected</span>
                        </h6>
                      </b-col>
                      <b-col cols="2" class="p-0 text-right">
                        <b-form-select v-model="selectedShowOption" :options="scheduleFormOptions" class="mb-3 fs-12 downArrow" size="sm" @change="showForms" />
                      </b-col>
                    </b-row>
                  </div>
                  <template>
                    <table class="tableBg1 forms-table create_packet create-edit-packet-page__add-forms-table" style="width: 100%">
                      <colgroup>
                        <col style="width: 3%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 23%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 16%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 14%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 22%" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th class="p-0"></th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('name')">
                            Name
                            <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('type')">
                            Type
                            <span class="sortUp" @click="sortUnselectedFormData('type', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('type', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th class="p-0">
                            Scheduled
                          </th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('createdBy')">
                            Created By
                            <span class="sortUp" @click="sortUnselectedFormData('createdBy', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('createdBy', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('groupName')">
                            Group
                            <span class="sortUp" @click="sortUnselectedFormData('groupName', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('groupName', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('stepsCount')">
                            Steps
                            <span class="sortUp" @click="sortUnselectedFormData('stepsCount', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('stepsCount', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('timeToComplete')">
                            Duration
                            <span class="sortUp" @click="sortUnselectedFormData('timeToComplete', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('timeToComplete', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th class="p-0">Languages</th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('modifiedTime')">
                            Last Modified
                            <span class="sortUp" @click="sortUnselectedFormData('modifiedTime', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('modifiedTime', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(form, index) in currentFormList" :key="index">
                          <td class="p-0" style="text-align: center">
                            <input type="checkbox" :id="form.id" :checked="isFormSelected(form.id)" @change="getFormCount(form)" />
                          </td>
                          <td>
                            <span class="form-name">
                              <router-link
                                v-if="form.type == 'EDC'"
                                :to="{
                                  name: 'study-form-view',
                                  params: { formId: form.id }
                                }"
                                class="color_4c8ce4"
                                >{{ form.name }}</router-link
                              >
                              <router-link
                                v-if="form.type != 'EDC'"
                                :to="{
                                  name: 'study-activity-form-view',
                                  params: { formId: form.id }
                                }"
                                class="color_4c8ce4"
                                >{{ form.name }}</router-link
                              >
                            </span>
                          </td>
                          <td class="form-text p-0 activity_type">
                            <span>{{ form.type }}</span>
                          </td>
                          <td>
                            <div class="p-0 schedulemilestone" v-if="form.milestonesList && form.milestonesList.length > 0">
                              <span v-for="(milestone, index) in getSortedMilestoneList(form, 0, 3)" :key="index" :id="'form_' + form.id + 'milestone_' + milestone.milestoneId">
                                {{ milestone.milestoneName }}
                                <span v-if="index + 1 < form.milestonesList.length">,</span>

                                <b-tooltip :target="'form_' + form.id + 'milestone_' + milestone.milestoneId">
                                  <div>
                                    <span>Milestone {{ index + 1 }}</span>
                                  </div>
                                  <div>
                                    <span>Day {{ milestone.milestoneDay }}</span>
                                  </div>
                                </b-tooltip>
                              </span>
                              <button v-if="form.milestonesList && form.milestonesList.length > 3" variant="primary" class="btn plus_btn" size="lg" :id="`selected-${form.id}-milestone`" tabindex="0">
                                +
                              </button>
                              <b-popover :target="`selected-${form.id}-milestone`" triggers="click blur" placement="right" container="data-capture-formId">
                                <div class="create-edit-packet-table__language-pop-over-container">
                                  <ul class="create-edit-packet-table__languages-list">
                                    <li class="create-edit-packet-table__languages-list-item" v-for="(milestone, index) in getSortedMilestoneList(form, 3, form.length)" :key="index" :id="'form_' + form.id + 'milestone_' + milestone.milestoneId">
                                      {{ milestone.milestoneName }}
                                    </li>
                                  </ul>
                                </div>
                              </b-popover>
                            </div>
                          </td>
                          <td class="p-0">{{ form.createdBy }}</td>
                          <td class="p-0">{{ form.groupName }}</td>
                          <td class="p-0">{{ form.stepsCount }}</td>
                          <td class="p-0">{{ form.timeToComplete }}</td>
                          <td class="p-0">
                            <span class="create-edit-packet-table__language-box" :id="`unselected-${form.id}-language`" tabindex="0">
                              {{ (form.language && form.language.length) || 0 }}
                            </span>
                            <b-popover :target="`unselected-${form.id}-language`" triggers="click blur" placement="left" container="create-edit-packet-page">
                              <div class="create-edit-packet-table__language-pop-over-container" v-if="form.language && form.language.length">
                                <ul class="create-edit-packet-table__languages-list">
                                  <li class="create-edit-packet-table__languages-list-item" v-for="(language, index) in getSortedLanguage(form.language)" :key="index">
                                    {{ language.display_name }}
                                  </li>
                                </ul>
                              </div>
                            </b-popover>
                          </td>
                          <td class="p-0 date-text">
                            {{ getLastModifiedTime(form) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <div class="tableBg3 mb-25">
                    <b-row class="pt-20">
                      <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                        <i class="fa fa-angle-left fs-23"></i>
                      </div>
                      <div class="pagination">{{ currentPage }}</div>
                      <div class="pagination2">of {{ totalPages }}</div>
                      <div
                        @click="nextPage"
                        class="arrow-icon cursor_pointer"
                        :class="{
                          disabledPagination: currentPage >= totalPages
                        }"
                      >
                        <i class="fa fa-angle-right fs-23"></i>
                      </div>
                    </b-row>
                  </div>
                </div>
              </div>

              <div class="pr-30 bt-pos pb-10">
                <router-link :to="{ name: 'study-activities', params: { studyId } }" class="mr-20">Cancel&nbsp;</router-link>
                <button v-if="selectedFormsData.length > 0" type="button" class="buttons btn fs-12 mr-10 primaryBgColor btn-primary btn-sm" @click="createPackets()">
                  Next
                </button>
                <button v-else type="button" class="buttons btn fs-12 mr-10 primaryBgColor btn-primary btn-sm">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderBy from "lodash/orderBy";
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import ceil from "lodash/ceil";
import slice from "lodash/slice";
import _ from "lodash";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "study-create-packet",
  components: {},
  data() {
    return {
      studyId: this.$route.params.studyId,
      formId: this.$route.params.formId,
      studyData: {},
      editFormNameInput: false,
      defaultFormName: "Form name (click to edit)",
      formName: window.localStorage.getItem("thread-edcFormName") || "Form name (click to edit)",
      savedFormFields: [],
      mode: "default",
      component: "",
      unscheduledPackets: [],
      edcformData: {},
      selectedPackets: "",
      forms: [],
      scheduleFormOptions: [],
      selectedShowOption: 10,
      currentFormList: [],
      currentPage: 1,
      totalPages: 1,
      selectedFormsData: [],
      searchTerm: "",
      notSelectedFormData: [],
      hover: false,
      sortMap: {
        name: "ASC",
        type: null,
        createdBy: null,
        groupName: null,
        stepsCount: null,
        timeToComplete: null,
        modifiedTime: null
      }
    };
  },
  computed: {
    isEditMode() {
      const editMode = this.component.length > 0 || this.editFormNameInput;
      this.toggleEDCFormEditMode(editMode);
      return editMode;
    }
  },
  methods: {
    getSortedLanguage(languages) {
      return sortBy(languages, [
        function(o) {
          return o.display_name.toLowerCase().trim();
        }
      ]);
    },
    getLastModifiedTime(form) {
      if (form.modifiedTime) {
        const modifiedTimeMoment = moment(form.modifiedTime, "YYYY-MM-DD HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    getMilestoneNamesString(form) {
      if (form.milestonesIds && form.milestonesIds.length) {
        return form.milestonesIds.join(", ");
      }
      return "";
    },
    sortUnselectedFormData(columnName, order) {
      this.sortMap[columnName] = order;
      let columnType = "string";
      if (columnName == "stepsCount" || columnName == "timeToComplete") {
        columnType = "number";
      }
      if (columnName == "modifiedTime") {
        columnType = "date";
      }
      if (columnType == "string") {
        this.sortByString(columnName, order);
      } else if (columnType == "number") {
        this.sortByNumber(columnName, order);
      } else if (columnType == "date") {
        this.sortByDate(columnName, order);
      }
      this.showForms(this.selectedShowOption);
      this.showPackets(this.packetShowOption);
      this.$forceUpdate();
    },
    sortByString(columnName, order) {
      if (order == "ASC") {
        this.notSelectedFormData.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            //sort string ascending
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else {
        this.notSelectedFormData.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }
          return 0;
        });
      }
    },
    sortByNumber(columnName, order) {
      if (order == "ASC") {
        this.notSelectedFormData.sort((a, b) => {
          return a[columnName] - b[columnName];
        });
      } else {
        this.notSelectedFormData.sort((a, b) => {
          return b[columnName] - a[columnName];
        });
      }
    },
    sortByDate(columnName, order) {
      if (order == "ASC") {
        this.notSelectedFormData.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateA - dateB;
        });
      } else {
        this.notSelectedFormData.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateB - dateA;
        });
      }
    },
    toggleSortForUnselectedFormData(columnName) {
      if (this.sortMap[columnName] == null || this.sortMap[columnName] == "DESC") {
        this.sortMap[columnName] = "ASC";
      } else {
        this.sortMap[columnName] = "DESC";
      }

      this.sortUnselectedFormData(columnName, this.sortMap[columnName]);
    },
    ...mapActions(["toggleEDCFormEditMode"]),
    createPackets() {
      const route = {
        name: "study-create-edit-packet",
        params: {
          studyId: this.studyId,
          formDatas: this.selectedFormsData,
          notSelectedFormDatas: this.notSelectedFormData,
          packetId: 0
        }
      };
      this.$router.push(route);
    },
    isFormSelected(formId) {
      const optionIndex = this.selectedFormsData.findIndex(element => element.id === formId);
      if (optionIndex === -1) {
        return false;
      } else {
        return true;
      }
    },
    getFormCount(formVal) {
      const optionIndex = this.selectedFormsData.findIndex(element => element.name === formVal.name);
      if (optionIndex === -1) {
        this.selectedFormsData.push(formVal);
      } else {
        this.selectedFormsData.splice(optionIndex, 1);
      }
      this.selectedFormsData = orderBy(this.selectedFormsData, ["name"], ["asc"]);

      const newOptionIndex = this.notSelectedFormData.findIndex(element => element.name === formVal.name);

      if (newOptionIndex === -1) {
        this.notSelectedFormData.push(formVal);
      } else {
        this.notSelectedFormData.splice(newOptionIndex, 1);
      }
    },
    showForms(selectedShowOption) {
      this.totalPages = ceil(this.forms.length / selectedShowOption) === 0 ? 1 : ceil(this.forms.length / selectedShowOption);
      this.selectedForms = [];
      let start = 0;
      let end = selectedShowOption;
      for (let index = 0; index < this.totalPages; index++) {
        this.selectedForms.push(slice(this.forms, start, end));
        start += selectedShowOption;
        end += selectedShowOption;
      }
      if (!this.scheduleFormOptions || !this.scheduleFormOptions.length) {
        for (let index = 1; index <= this.totalPages; index++) {
          this.scheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.currentPage = 1;
      this.currentFormList = this.selectedForms[this.currentPage - 1];
      this.notSelectedFormData = this.forms;
    },
    searchFormName(searchTerm) {
      if (searchTerm) {
        let search = searchTerm;
        search = search.trim();
        this.forms = this.allForms;
        this.forms = filter(this.forms, form => form.name.toLowerCase().includes(search.toLowerCase()));
        this.showForms(this.selectedShowOption);
        this.showPackets(this.packetShowOption);
      } else {
        this.forms = this.allForms;
        this.showForms(this.selectedShowOption);
        this.showPackets(this.packetShowOption);
      }
    },
    showPackets() {
      this.selectedPackets = [];
      this.currentPacketPage = 1;
      this.currentPacketList = this.selectedPackets[this.currentPacketPage - 1];
    },
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        this.currentPage -= 1;
        this.currentFormList = this.selectedForms[this.currentPage - 1];
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentFormList = this.selectedForms[this.currentPage];
        this.currentPage += 1;
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(response => {
        this.studyData = response.body;
      });
    },
    closeModal(ref) {
      this.$refs[ref].hide();
    },
    preventDropDownHide(event) {
      event.stopPropagation();
    },

    getEDCFormDetails() {
      this.$api.getEDCFormsList(this.studyId).then(response => {
        this.allForms = response.body;
        this.allForms = orderBy(this.allForms, ["name"], ["asc"]);
        this.forms = this.allForms;

        this.forms.forEach((form, index) => {
          const data = form;
          data.index = index + 1;
        });
        this.showForms(this.selectedShowOption);
      });
    },
    getSortedMilestoneList(form, start, end) {
      const formClone = _.cloneDeep(form);
      formClone.milestonesList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
      return formClone.milestonesList.slice(start, end);
    }
  },
  mounted() {
    this.getEDCFormDetails();
  }
};
</script>

<style lang="scss">
.popover {
  width: auto !important;
  margin: 0 !important;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  left: -8px !important;
  border: none;
  .popover-body {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
<style scoped lang="scss">
.main-container {
  background-color: #f5f6f7 !important;
  height: 100% !important;
  min-height: 100vh;
}

.pt-55 {
  padding-top: 55px !important;
}

.pr-65 {
  padding-right: 65px !important;
}

.center-area {
  z-index: 90;
}

.dataTables_search input {
  width: 96%;
  height: 37px;
  background-image: url(/static/img/activity-configurator/activity-library-search.svg) !important;
  background-position: right 2% top 80% !important;
  background-repeat: no-repeat;
  background-size: 26px 27px;
  border-radius: 0.2rem;
}

.tableBg1 {
  background-color: #ffffff !important;
  padding: 24px 20px 0px 20px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-top: none;
}
.tableBg2 {
  background-color: #ffffff !important;
  padding: 10px 20px 5px 20px !important;
  border-left: 1px solid #d3dfe4;
  border-right: 1px solid #d3dfe4;
}
.tableBg3 {
  background-color: #ffffff !important;
  padding: 10px 20px 14px 20px !important;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #d3dfe4;
}

.noOfFormsText {
  font-size: 16px;
  font-family: RobotoBold;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.noOfForms {
  font-weight: bold;
  color: #f16559;
  padding-right: 5px;
}

.form-title {
  font-size: 11px;
  font-weight: bold;
  letter-spacing: normal;
  color: #b0bac9;
}

.form-name {
  width: auto;
  height: 24px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #4c8ce4;
}

input[type="checkbox"] {
  height: 21px;
  width: 21px;
}
.custom-control-input {
  z-index: 1;
  left: 7px;
}
input[type="checkbox"]:checked + span:before {
  background-color: #4c8ce4;
  border: 0.1em solid #4c8ce4;
  color: #fff;
  font-size: 14px;
  padding-bottom: 5px;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 28px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 28px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.cursor-pointer {
  cursor: pointer;
}

.downArrow {
  background-image: url("/static/img/down-arrow.png") !important;
  background-size: 16px 16px;
  background-position: 95% 50% !important;
  width: 135px;
}

.buttons {
  width: 109px;
  height: 36px;
  border-radius: 100px;
}

.bt-pos {
  float: right;
}
.can-btn-text {
  height: 20px;
  font-size: 15px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.studys_schedule {
  font-size: 12px;
}
.hr {
  border-bottom: 1px solid #eee;
}
.disabledPagination {
  pointer-events: none;
}
.cursor-pointer {
  cursor: pointer;
}
.preview-background-grey {
  background-color: rgba(211, 223, 228, 0.6);
}
.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
  width: 0;
  height: 0;
  background: transparent;
  border-top-width: 0;
  cursor: pointer;
}
.sortDown {
  position: relative;
  padding-left: 4px;
  width: 0;
  height: 0;
  cursor: pointer;
  top: 5px;
  z-index: 1;
}
.plus_btn {
  width: 26px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #d3dee3;
  background-color: #ffffff;
  color: blue;
  padding: 0;
  line-height: 20px;
}
.schedulemilestone span:nth-child(3) span {
  display: none;
}
.create-edit-packet-table {
  &__language-box {
    width: 35px;
    height: 24px;
    font-size: 14px;
    font-weight: bold;
    color: #4c8ce4;
    border: 1px solid #d3dee3 !important;
    border-radius: 4px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    line-height: 22px;

    &:focus {
      outline: none;
    }
  }

  &__language-pop-over-container {
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    overflow-y: scroll;
    max-height: 258px;
    scrollbar-width: thin; /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

    &::-webkit-scrollbar {
      width: 5px; /* width of the entire scrollbar */
      max-height: 15%;
    }
    &::-webkit-scrollbar-track {
      background: transparent; /* color of the tracking area */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9; /* color of the scroll thumb */
      border-radius: 20px; /* roundness of the scroll thumb */
      border: 3px solid transparent; /* creates padding around scroll thumb */
    }
  }

  &__languages-list {
    list-style: none;
    padding-left: 15px;
    padding-top: 9px;
  }

  &__languages-list-item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    color: #000000;
  }
}
.create-edit-packet-page {
  &__order-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }
  }

  &__add-forms-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }

    input[type="checkbox"] {
      // display: none;
      height: 21px;
      width: 21px;
    }
  }

  &__order-table,
  &__add-forms-table {
    th {
      font-family: "RobotoRegular";
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.18;
      letter-spacing: normal;
      color: #b0bac9;
    }

    td {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 16px;
      letter-spacing: normal;
      color: #000000;
    }

    .activity_type {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }
  }
}
.activity-form {
  min-height: 647px;
  position: relative;
  padding-top: 21px !important;
  // padding-right: 30px !important;
}
</style>
